module.exports = __webpack_public_path__ + "static/media/folder-grey.3cd44bd2.png";